/**
 * Environment-variable access that works across every runtime this app runs in:
 *
 * - Vite dev server and production build  -> `import.meta.env` (Vite inlines
 *   any `VITE_`-prefixed vars, and we also expose the legacy `REACT_APP_*`
 *   names there via `envPrefix` in vite.config.js).
 * - Vitest / jsdom and any Node context   -> `process.env` fallback.
 *
 * Reading an undefined key returns `undefined` instead of throwing
 * `ReferenceError: process is not defined`, matching Create React App's
 * old behavior where `process.env` always existed in the bundle.
 */
function readEnv(key) {
  // import.meta.env is always defined under Vite (dev + build).
  const viteEnv =
    typeof import.meta !== "undefined" && import.meta.env
      ? import.meta.env
      : undefined;
  if (viteEnv && key in viteEnv) {
    return viteEnv[key];
  }

  // Fallback for test runners / Node where process.env is available.
  if (typeof process !== "undefined" && process.env && key in process.env) {
    return process.env[key];
  }

  return undefined;
}

export const REACT_APP_VERCEL_ENV = readEnv("REACT_APP_VERCEL_ENV");
export const REACT_APP_ENV = readEnv("REACT_APP_ENV");

export default readEnv;
